let service = function($window) {
	"ngInject";
	return $window._;
};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/lodash.service.js